import React, { Component } from 'react'

import { Modal, Row, Col, FormControl, FormLabel, Form } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import { Tooltip, IconButton } from '@material-ui/core'
import Select from 'react-select'
import { BsPencil } from 'react-icons/bs'

export default class NewUser extends Component<any> {
  state = {
    update: false,
    loading: false,
    show: true,
    detail: false,
    NoPassword: false,
    user: {
      username: undefined,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      description: undefined,
      company: undefined,
      phone: undefined,
      position: undefined,
      password: undefined,
      confirmPassword: undefined,
      canViewMacroEco: false,
      canEditMacroEco: false,
      canViewReport: false,
      canViewVideo: false,
      isSendMail: true,
      requirePassword: true,
      role: 'customer'
    },
    firstCompany: [{}],
    role: [
      { label: 'admin', value: 'admin' },
      { label: 'customer', value: 'customer' }
    ],
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open)
      if (nextProps.detail) {
        this.setState({
          loading: false, show: true,
          detail: true,
          user: {
            username: nextProps.open.row.username,
            firstName: nextProps.open.row.firstName,
            lastName: nextProps.open.row.lastName,
            email: nextProps.open.row.email,
            description: nextProps.open.row.description,
            company: nextProps.open.row.company,
            phone: nextProps.open.row.phone,
            position: nextProps.open.row.position,
            password: nextProps.open.row.password,
            confirmPassword: nextProps.open.row.confirmPassword,
            canViewMacroEco: nextProps.open.row.canViewMacroEco,
            canEditMacroEco: nextProps.open.row.canEditMacroEco,
            canViewReport: nextProps.open.row.canViewReport,
            canViewVideo: nextProps.open.row.canViewVideo,
            isSendMail: nextProps.open.row.isSendMail,
            requirePassword: nextProps.open.row.requirePassword,
            role: nextProps.open.row.role,
          }
        })
      }
    if ((nextProps.open.row || {}).company) {
      this.setState({
        firstCompany: [
          {
            label: nextProps.open.row.company,
            value: nextProps.open.row.company
          }
        ]
      })
    }
  }

  onReturn = () => {
    this.setState({
      loading: false, update: false,
      user: {
        username: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        description: undefined,
        company: undefined,
        phone: undefined,
        position: undefined,
        password: undefined,
        confirmPassword: undefined,
        canViewMacroEco: false,
        canEditMacroEco: false,
        canViewReport: false,
        canViewVideo: false,
        isSendMail: true,
      }
    })
    this.props.cancel()
  }

  onModalConfirm = () => {
    this.setState({ loading: true })
    this.props.callback({ data: this.state.user, update: this.state.detail }).then(isSuccess => {
      isSuccess ? this.onReturn() : this.setState({ loading: false })
    })
  }

  handleClose = () => {
    this.setState({ update: false })
    this.props.cancel()
  }

  handleFormSelect = (e) => {
    let { user } = this.state
    user.company = e ? e.value : undefined
    this.setState({ user, update: this.state.detail ? true : false })
  }

  handleFormSelectRole = (e) => {
    let { user } = this.state
    user.role = e.value
    this.setState({ user, update: this.state.detail ? true : false })
  }

  render() {

    return (
      <Modal show={this.state.show && this.props.open.show}>
        <Modal.Header>
          <Modal.Title>{this.state.detail ? "User Detail" : "Create New User"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Username</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="username" placeholder="Username" style={{ marginTop: '5px' }} disabled={this.state.detail} value={this.state.user.username || ""} onChange={this.handleUser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>E-mail</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="email" placeholder="E-mail" style={{ marginTop: '5px' }} disabled={this.state.detail} value={this.state.user.email || ""} onChange={this.handleUser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>First Name</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="firstName" placeholder="First Name" style={{ marginTop: '5px' }} value={this.state.user.firstName || ""} onChange={this.handleUser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Last Name</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="lastName" placeholder="Last Name" style={{ marginTop: '5px' }} value={this.state.user.lastName || ""} onChange={this.handleUser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Description</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="description" placeholder="Description" style={{ marginTop: '5px' }} value={this.state.user.description || ""} onChange={this.handleUser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}>
              <FormLabel style={{ marginTop: '6px' }}>
                Company
                <Tooltip title="Edit Section" aria-label="add">
                  <IconButton aria-label="delete" style={{ marginLeft: "3px" }} onClick={() => this.props.handleData(!this.state.detail ? "new" : "edit", this.state.user)}>
                    <BsPencil style={{ color: "blue" }} />
                  </IconButton>
                </Tooltip>
              </FormLabel>
            </Col>
            <Col xs={12} sm={7} style={{ marginTop: '6px' }} >
              <Select
                className="basic-single"
                classNamePrefix="select"
                onChange={this.handleFormSelect}
                defaultValue={this.state.firstCompany[0]}
                isSearchable
                isClearable
                name="section"
                options={this.props.company}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "-10px" }}>
            <Col xs={12} sm={4}>
              <FormLabel style={{ marginTop: '6px' }}>
                Role
              </FormLabel>
            </Col>
            <Col xs={12} sm={7} style={{ marginTop: '6px' }} >
              <Select
                className="basic-single"
                classNamePrefix="select"
                onChange={this.handleFormSelectRole}
                defaultValue={this.state.role.find(r => r.value === this.state.user.role)}
                name="role"
                options={this.state.role}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Phone</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="phone" placeholder="Phone" style={{ marginTop: '6px' }} value={this.state.user.phone || ""} onChange={this.handlePhone} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Position</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="position" placeholder="Position" style={{ marginTop: '5px' }} value={this.state.user.position || ""} onChange={this.handleUser} />
            </Col>
          </Row>
          <Row>
            <Col xs={7} sm={4}><FormLabel style={{ marginTop: '6px' }}>No Password</FormLabel></Col>
            <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
              <Form.Check
                id={`default-switchNopass`}
                onClick={this.handleNoPassword}
                defaultChecked={!this.state.user.requirePassword}
              />
            </Col>
          </Row>
          {!this.state.detail && this.state.user.requirePassword && <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Password</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="password" name="password" placeholder="Password" style={{ marginTop: '5px' }} value={this.state.user.password || ""} onChange={this.handleUser} />
            </Col>
          </Row>}
          {!this.state.detail && this.state.user.requirePassword && <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: '6px' }}>Confirm Password</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="password" name="confirmPassword" placeholder="Confirm Password" style={{ marginTop: '5px' }} value={this.state.user.confirmPassword || ""} onChange={this.handleUser} />
            </Col>
          </Row>}
          <Row>
            <Col xs={4}><FormLabel style={{ marginTop: '6px' }}>Macroeconomics</FormLabel></Col>
            <Col xs={3} style={{ marginTop: '6px', paddingRight: 0 }}>
              View
              <Form.Check
                type="switch"
                name="canViewMacroEco"
                id={`default-switch1-1`}
                onClick={this.handleUser}
                checked={this.state.user.canViewMacroEco || this.state.user.role === 'admin'}
                style={{ display: "inline", marginLeft: 8 }}
                disabled={this.state.user.role === 'admin'}
              />
            </Col>
            <Col xs={3} style={{ marginTop: '6px' }}>
              Edit
              <Form.Check
                type="switch"
                name="canEditMacroEco"
                id={`default-switch1-2`}
                onClick={this.handleUser}
                checked={this.state.user.canEditMacroEco}
                style={{ display: "inline", marginLeft: 8 }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={7} sm={4}><FormLabel style={{ marginTop: '6px' }}>Research</FormLabel></Col>
            <Col xs={5} sm={3} style={{ marginTop: '6px' }}>
              View
              <Form.Check
                type="switch"
                name="canViewReport"
                id={`default-switch2-1`}
                onClick={this.handleUser}
                checked={this.state.user.canViewReport || this.state.user.role === 'admin'}
                style={{ display: "inline", marginLeft: 8 }}
                disabled={this.state.user.role === 'admin'}
              />
            </Col>
            <Col xs={3} style={{ marginTop: '6px' }}>
              Edit
              <Form.Check
                type="switch"
                name="canEditReport"
                id={`default-switch2-2`}
                checked={this.state.user.role === 'admin'}
                style={{ display: "inline", marginLeft: 8 }}
                disabled
              />
            </Col>
          </Row>
          <Row>
            <Col xs={7} sm={4}><FormLabel style={{ marginTop: '6px' }}>Video</FormLabel></Col>
            <Col xs={5} sm={3} style={{ marginTop: '6px' }}>
              View
              <Form.Check
                type="switch"
                name="canViewVideo"
                id={`default-switch3-1`}
                onClick={this.handleUser}
                checked={this.state.user.canViewVideo}
                style={{ display: "inline", marginLeft: 8 }}
                disabled={this.state.user.role === 'admin' || this.state.user.role === 'admin'}
              />
            </Col>
            <Col xs={3} style={{ marginTop: '6px' }}>
              Edit
              <Form.Check
                type="switch"
                name="canEditVideo"
                id={`default-switch3-2`}
                checked={this.state.user.role === 'admin'}
                style={{ display: "inline", marginLeft: 8 }}
                disabled
              />
            </Col>
          </Row>
          {!this.state.detail && false && <Row>
            <Col xs={7} sm={4}><FormLabel style={{ marginTop: '6px' }}>Send Mail To User</FormLabel></Col>
            <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
              <Form.Check
                type="switch"
                name="isSendMail"
                id={`default`}
                onClick={this.handleUser}
                defaultChecked={this.state.user.isSendMail}
              />
            </Col>
          </Row>}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success"
            loading={this.state.loading}
            onClick={this.onModalConfirm}
            disabled={
              (this.state.detail ? !this.state.update : true) &&
              (
                (this.state.user.username || "").length === 0 ||
                (this.state.user.email || "").length === 0 ||
                (this.state.user.requirePassword && this.state.user.password && ((this.state.user.password || "").length === 0 || (this.state.user.confirmPassword || "").length === 0)) ||
                (this.state.user.requirePassword && this.state.user.password && this.state.user.password !== this.state.user.confirmPassword)
              )
            }>
            {this.state.loading ? 'Please wait' : 'Save'}
          </Button>
          <Button bsStyle="default" onClick={() => this.handleClose()}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  handleNoPassword = () => {
    const { user } = this.state
    user.requirePassword = !user.requirePassword
    user.password = undefined
    user.confirmPassword = undefined
    this.setState({ user, update: this.state.detail ? true : false })
  }

  handleUser = (event) => {
    let user = this.state.user
    user[event.target.name] = [
      "canViewMacroEco",
      "canEditMacroEco",
      "canViewReport",
      "canViewVideo",
      "isSendMail",
    ].includes(event.target.name)
      ? event.target.checked
      : event.target.value
    this.setState({ user, update: this.state.detail ? true : false })
  }

  handlePhone = (event) => {
    let user = this.state.user
    if (event.target.value.length <= 10 && event.target.value.match(/^[0-9]+$/)) user[event.target.name] = event.target.value
    else if (event.target.value === "") user[event.target.name] = ""
    this.setState({ user, update: this.state.detail ? true : false })
  }
}